import { Button, Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { SupplierListFilters } from '@/modules/suppliers/supplier-list/supplier-list-filters.component';
import { supplierListColumns } from '@/modules/suppliers/supplier-list/supplier-list.column';
import { useSupplierList } from '@/modules/suppliers/supplier-list/supplier-list.hook';

export const SupplierList = () => {
    const { error, data, isError, isLoading, isFetching, handleAddSupplier } =
        useSupplierList();
    return (
        <SectionContainer error={error} isError={isError} isLoading={isLoading}>
            <Card className="min-w-0 space-y-4 overflow-hidden p-3 sm:p-4">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                    <div className={'space-y-4'}>
                        <HeaderBreadcrumb items={[{ label: 'Suppliers' }]} />
                        <SectionTitle>Suppliers</SectionTitle>
                    </div>
                    <Button
                        type={'button'}
                        className="w-full sm:w-auto"
                        onClick={handleAddSupplier}
                    >
                        Add Supplier
                    </Button>
                </div>
                <SupplierListFilters />
                <div className="min-w-0 [&_[role=navigation]>ul]:min-w-max [&_[role=navigation]]:justify-start [&_[role=navigation]]:overflow-x-auto sm:[&_[role=navigation]]:justify-center">
                    <SectionDataTable
                        columns={supplierListColumns}
                        data={data}
                        isLoading={isLoading || isFetching}
                    />
                </div>
            </Card>
        </SectionContainer>
    );
};

SupplierList.displayName = 'SupplierList';
